/**
 * Tarihi yerel saate göre ISO-benzeri formata çevirir (UTC'ye kaymaz).
 * toISOString() yerine bunu kullan - kullanıcı 23 Nisan seçtiyse 2026-04-23 gönderilir,
 * timezone farkı nedeniyle 22 Nisan olmaz.
 *
 * @param date Date nesnesi
 * @returns "YYYY-MM-DDTHH:mm:ss" formatında string (local time)
 */
export function toLocalISOString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}
